import { Button } from "antd";
import React from "react";

const Basic = ({
  disabled,
  icon,
  loading,
  shape,
  type,
  size,
  color,
  text,
  onClick,
  containerStyle,
  buttonStyle,
  classes,
  sx,
  ...props
}) => (
  <Button
    disabled={disabled}
    icon={icon}
    loading={loading}
    shape={shape}
    size={size} // 'small'| 'medium'| 'large'
    type={type}
    color={color}
    onClick={onClick}
    style={buttonStyle}
    className={classes}
    {...props}
  >
    {text}
  </Button>
);

export default Basic;
